<div class="At-Wrapper">
    <section class="At-SectionLogin">
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-md-5 at_Mainlogin At-CustomCol-47 d-flex align-items-center justify-content-center">
                    <div class="At-LoginFormGeneral At-LoginFormVerifyEmail">
                        <a class="At-BtnBack At-BtnLinkBlue" (click)="backClicked()" href="javascript:void(0);">
                            <i class="icon-back-arrow"></i> <h5>BACK</h5>
                        </a>
                        <div class="At-ImgHolder At-ImgHolderLoginLogo">
                            <i class="icon-logo"></i>
                        </div>
                        <h2>Verify Email</h2>
                        <h5>johnathan.smith@gmail.com</h5>
                        <div class="At-forgotContent">
                          <h5>A verification email have been send to your given id. 
                            Kindly confirm your email to proceed ahead to 
                            creating your profile</h5>
                        </div>
                        <div class="At-DntHaveAccount">
                            <h6>Haven’t received an email yet? <a href="javascript:void(0);">SEND AGAIN</a></h6>
                        </div>
                    </div>
                </div>
                <!-- at_Mainlogin ends -->

                <div class="col-md-7 At-BannerLogin At-CustomCol-53 d-flex align-items-center justify-content-center">
                    <div class="At-ImgHolder">
                        <figure>
                            <img src="assets/images/verify-right-bg.png" class="img-fluid" alt="">
                        </figure>
                    </div>
                    <a class="At-GetMobileAppLink" href="javascript:void(0);">GET YOUR MOBILE APP   >></a>
                </div>
                <!-- At-BannerLogin ends -->
            </div>
        </div>
    </section>
</div>